import { render, staticRenderFns } from "./GroupsDropdown.vue?vue&type=template&id=d28ff322&"
import script from "./GroupsDropdown.vue?vue&type=script&lang=ts&"
export * from "./GroupsDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports